module.exports = __webpack_public_path__ + "img/ic_band_left_select.b236bae9.png";